import type { AufgabenAnsicht } from '../../shared/guide-aufgaben';

/** Only the already-authorized full view supplies these links. No fetch or action here. */
export function GuideVerknuepfteAufgaben({ aufgaben }: {
  aufgaben: AufgabenAnsicht['verknuepfteAufgaben'];
}) {
  if (!aufgaben?.length) return null;
  const stand = {
    erfasst: 'Erfasst', geplant: 'Als Nächstes', in_arbeit: 'Als in Arbeit gemeldet',
    blockiert: 'Abhängigkeit offen', erledigt: 'Erledigt', zurueckgestellt: 'Zurückgestellt',
  };
  return <section aria-label="Zugehörige Arbeit auf anderer Bühne" data-ai-id="guide-verknuepfte-aufgaben">
    <h4>Zugehörige Arbeit auf anderer Bühne</h4>
    {aufgaben.map(aufgabe => <article key={aufgabe.id} style={{ padding: '10px 0', borderTop: '1px solid var(--tn-border)' }}>
      <strong>{aufgabe.text}</strong>
      <small style={{ display: 'block', marginTop: 4 }}>{stand[aufgabe.zustand]} · {aufgabe.buehnenTitel}</small>
      <p>{aufgabe.bezug}</p>
      {!aufgabe.bezugAktuell && <p role="status">Der Fortschritt hat sich geändert. Der Berater muss den Bezug zu dieser Bühne erneut abgleichen.</p>}
      {aufgabe.ergebnis && <p>Ergebnis: {aufgabe.ergebnis.befund}</p>}
      {aufgabe.zustand !== 'erledigt' && <p>Nächster Schritt: {aufgabe.naechsterSchritt}</p>}
      <details><summary>Zuständigkeit, Ziel und Belege</summary>
        <p>Zuständig: {aufgabe.zustaendig}</p>
        <p>Ziel: {aufgabe.ziel}</p>
        <p>Bezug: {aufgabe.referenz}</p>
        {aufgabe.ergebnis && <p>Ergebnisbeleg: {aufgabe.ergebnis.referenz}</p>}
      </details>
    </article>)}
  </section>;
}
